export function handleNetworkError(error, reload = false) {
    return (dispatch, getState) => {
        if (!error.response) {
            // Assume the request timed out, or that the network is unavailable
            dispatch({ type: 'TOGGLE_SHOW_NETWORK_ERROR_PAGE', payload: true })
        }
    }
}
